$(function(){
    function handleChatWithSalesOnClick(){
        // Triggers marked data-force-form always open the popup form, never Kustomer
        if ($(this).data('force-form')) {
            var $formPopup = $('.chat-with-sales-popup-pdp').first();
            if ($formPopup.length > 0) {
                Simplistic.openModal($formPopup, 'regular');
            }
            return false;
        }

        // Check if Kustomer chat widget is loaded and available
        if (window.Kustomer && typeof window.Kustomer.isChatAvailable === 'function') {
            try {
                var chatStatus = window.Kustomer.isChatAvailable();

                // Only open chat if it's online (available)
                if (chatStatus && chatStatus.availability === 'online') {
                    // Chat is available, open it
                    window.Kustomer.open();
                } else {
                    // Chat is not available (offline, disabled, hidden, or none), show custom popup
                    var $popup = $('.chat-with-sales-popup-pdp').first();
                    if ($popup.length > 0) {
                        Simplistic.openModal($popup, 'regular');
                    }
                }
            } catch (error) {
                // Error checking chat availability, fallback to custom popup
                console.log('Error checking Kustomer availability:', error);
                var $popup = $('.chat-with-sales-popup-pdp').first();
                if ($popup.length > 0) {
                    Simplistic.openModal($popup, 'regular');
                }
            }
        } else {
            // Kustomer not loaded, fallback to custom popup
            var $popup = $('.chat-with-sales-popup-pdp').first();
            if ($popup.length > 0) {
                Simplistic.openModal($popup, 'regular');
            }
        }

        return false;
    }
    
    $(document).off('click', '.chat-with-sales-button-pdp');
    $(document).on('click', '.chat-with-sales-button-pdp', handleChatWithSalesOnClick);
    
    // Handle form submission with multiple approaches to ensure it's caught
    function handlePDPFormSubmit(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        
        var form = $(e.target);
        var error = false;
        
        form.parent().find('.error-msg').hide().text('');
        form.find('.error').removeClass('error').removeAttr('aria-invalid');
    
        // Validate required fields
        form.find('.required').each(function(){
            if($(this).val().trim() == "") {
                error = true;
                $(this).addClass('error').attr('aria-invalid', 'true');
            }
        });
        
        if(error){
            form.parent().find('.error-msg').show().text('Please complete all the required fields.');
        } else {
            // Validate email
            var emailValue = form.find('input[name="contact[email]"]').val();
            if(!Simplistic.validateEmail(emailValue)) {
                error = true;
                form.find('input[name="contact[email]"]').addClass('error').attr('aria-invalid', 'true');
                form.parent().find('.error-msg').show().text('Please provide a valid email address.');
            }
        }

        // Send keyboard and screen reader users to the first field that needs fixing
        if(error) {
            form.find('.error').first().trigger('focus');
        }
    
        if(!error) {
            var name = form.find('input[name="contact[name]"]').val() || '';
            var email = form.find('input[name="contact[email]"]').val() || '';
            var phone = form.find('input[name="contact[phone]"]').val() || '';
            var product = form.find('input[name="contact[product]"]').val() || '';
            var variant = form.find('input[name="contact[variant]"]').val() || '';
            var message = form.find('textarea[name="contact[message]"]').val() || '';

            // Submit to the HubSpot Chat With Sales form, with the field names
            // sections/custom-chat-with-sales.liquid sends to the same form. It has no
            // product field, so the product and its details go in referring_product_variant.
            var productVariant = [product, variant].filter(Boolean).join(': ');

            $.ajax({
                url: 'https://api.hsforms.com/submissions/v3/integration/submit/5361087/13675c0e-ee7b-40b0-94cc-9c106c91b238',
                type: 'POST',
                contentType: 'application/json',
                data: JSON.stringify({
                    fields: [
                        {name: 'referring_url', value: window.location.href},
                        {name: 'referring_product_variant', value: productVariant},
                        {name: 'email', value: email},
                        {name: 'firstname', value: name.split(' ')[0] || ''},
                        {name: 'lastname', value: name.split(' ').slice(1).join(' ') || ''},
                        {name: 'phone', value: phone},
                        {name: 'message', value: message}
                    ],
                    context: {
                        hutk: getHubSpotCookie(),
                        pageUri: window.location.href,
                        pageName: document.title
                    }
                }),
                success: function() {
                    // Also add them to back-in-stock notifications (Klaviyo)
                    var variantId;
                    // Check if we're in a quick-view modal
                    if ($('.tingle-modal .quick-view').length > 0) {
                        // In quick-view modal, get the addon variant ID
                        variantId = $('.tingle-modal .quick-view [name^=id]').val() || $('.tingle-modal .quick-view .select-variant').val();
                    } else {
                        // Regular PDP context
                        variantId = $('.add-to-cart-form [name^=id]').val();
                    }
                    if (variantId && email) {
                        addToBackInStock(email, variantId);
                    }

                    // Show success message
                    form.parent().hide();
                    form.parent().parent().find('.success-msg').show().find('h2').trigger('focus');
                },
                error: function(xhr, status, error) {
                    form.parent().find('.error-msg').show().text('There was an error sending your message. Please try again or email us directly.');
                    console.error('HubSpot form submission error:', xhr.status, xhr.responseText || error);
                }
            });
        }
    }

    function getHubSpotCookie() {
        var hubspotCookie = document.cookie.split(';').find(function(cookie) {
            return cookie.trim().indexOf('hubspotutk=') === 0;
        });
        return hubspotCookie ? hubspotCookie.trim().substring('hubspotutk='.length) : '';
    }
    
    // Multiple binding approaches to ensure our handler is called
    $(document).off('submit', '.chat-with-sales-popup-pdp form');
    $(document).on('submit', '.chat-with-sales-popup-pdp form', handlePDPFormSubmit);
    
    // Also bind directly when modal opens
    $(document).on('click', '.chat-with-sales-button-pdp', function() {
        setTimeout(function() {
            $('.chat-with-sales-popup-pdp form').off('submit').on('submit', handlePDPFormSubmit);
        }, 200);
    });
    
    // Also bind when tingle modal opens
    $(document).on('DOMNodeInserted', '.tingle-modal-box__content', function() {
        $('.chat-with-sales-popup-pdp form').off('submit').on('submit', handlePDPFormSubmit);
    });
    
    // Function to add contact to back-in-stock notifications
    function addToBackInStock(email, shopifyVariantId) {
        var klaviyoPublicKey = 'MBDndx';
        
        var backInStockPayload = {
            "data": {
                "type": "back-in-stock-subscription",
                "attributes": {
                    "profile": {
                        "data": {
                            "type": "profile",
                            "attributes": {
                                "email": email
                            }
                        }
                    },
                    "channels": ["EMAIL"]
                },
                "relationships": {
                    "variant": {
                        "data": {
                            "type": "catalog-variant",
                            "id": "$shopify:::$default:::" + shopifyVariantId
                        }
                    }
                }
            }
        };

        fetch("https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=" + klaviyoPublicKey, {
            method: 'POST',
            headers: {
                "Content-Type": "application/json",
                "revision": "2024-06-15"
            },
            body: JSON.stringify(backInStockPayload)
        })
        .then(function(response) {
            if (response.status === 202) {
                console.log('Successfully added to back-in-stock notifications');
            } else {
                console.log('Back-in-stock subscription response:', response.status);
            }
        })
        .catch(function(error) {
            console.log('Back-in-stock subscription error:', error);
        });
    }
    });


